import './defect-material-view.scss'

import { FormApi } from 'final-form';
import Component from 'vue-class-component';

import { ReactiveVue } from '@skinsoft/reactive-vue';

import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { DefectMaterial } from '@skinsoft/entity';
import { createTranslatedString, DeleteValidationOverlay, ThesaurusTermChooser } from '@skinsoft/ui';

import { Watch } from 'vue-property-decorator';
import { DefectAlterationView } from '../defect-alteration-view';

@Component({
    components: {
        sDefectAlterationView: DefectAlterationView,
        sDeleteValidationOverlay: DeleteValidationOverlay,
        sThesaurusTermChooser: ThesaurusTermChooser,
    },
    props: ['defectMaterial', 'materialIndex', 'form', 'fieldName', 'currentTypeOfObsTermId', 'elementName', 'deletable'],
    template: require('./defect-material-view.html')
})
export class DefectMaterialView extends ReactiveVue {

    public defectMaterial: DefectMaterial;
    public materialIndex: number;
    public form: FormApi;
    public fieldName: string;
    // Currently selected type of observation in parent, used to adapt select options for material choice
    public currentTypeOfObsTermId: string;
    public elementName: string;
    public deletable: boolean;

    private currentMaterialTermId: string = "";
    private displayDeleteOverlay: boolean = false;

    // Icons
    private plusIcon = faPlusCircle;
    private deleteIcon = faTrash;

    // used to generate an id for v-for feature (v-bind:key)
    private lastId = 1;

    public created() {
        this.$on('delete-alteration', (message) => {
            this.defectAlterations.splice(message.alterationIndex, 1)
        })

        this.$on('field-value-changed', (message) => {
            this.currentMaterialTermId = message.value;
        })

        // Catching delete-overlay events
        this.$on('deletion-validated-topic', this.deleteMaterial)
        this.$on('deletion-canceled-topic', this.toggleOverlay)
    }

    public get defectAlterations() {
        if (!this.defectMaterial.alterations) {
            this.defectMaterial.alterations = []
        }
        return this.defectMaterial.alterations;
    }

    public alterationsFieldname(index) {
        return `${this.fieldName}.alterations[${index}`
    }

    public get materialFieldName() {
        return `${this.fieldName}.material`
    }

    public createAlteration() {
        if (!this.defectMaterial.alterations) {
            this.defectMaterial.alterations = []
        }
        this.defectMaterial.alterations.push({
            annotations: [],
            id: this.lastId++,
            precision: createTranslatedString(this.$i18n.locale),
            typeOfAlteration: ""
        })
    }

    public deleteMaterial() {
        this.$parent.$emit('delete-material', { materialIndex: this.materialIndex })
    }

    public toggleOverlay() {
        this.displayDeleteOverlay = !this.displayDeleteOverlay
    }

    @Watch('defectMaterial', { immediate: true, deep: true })
    public onDefectObservationChange() {
        this.currentMaterialTermId = this.defectMaterial.material
        this.displayDeleteOverlay = false;
    }

}